import * as React from 'react';
import cx from 'classnames';

import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/Divider.scss';

/**
 * ## [Horizontal rule](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/hr) with built-in vertical padding.
 *
 *
 * ```example
 * <div>
 *   <Divider size="xlarge" />
 *   <Divider />
 *   <Divider size="medium" />
 *   <Divider size="small" />
 * </div>
 * ```
 */

type Props = {
  className?: string;
  element?: 'hr' | 'li';
  size?:
    | 'xxxxxlarge'
    | 'xxxxlarge'
    | 'xxxlarge'
    | 'xlarge'
    | 'large'
    | 'medium'
    | 'small'
    | 'xsmall'
    | 'xxsmall'
    | 'flush';
};

export default class Divider extends React.Component<Props> {
  static propClasses = {
    size: {
      xxxxxlarge: 'Divider--xxxxxlarge',
      xxxxlarge: 'Divider--xxxxlarge',
      xxxlarge: 'Divider--xxxlarge',
      xlarge: 'Divider--xlarge',
      large: 'Divider--large',
      medium: 'Divider--medium',
      small: 'Divider--small',
      xsmall: 'Divider--xsmall',
      xxsmall: 'Divider--xxsmall',
      flush: 'Divider--flush',
    },
  };

  static defaultProps = {
    element: 'hr',
    size: 'large',
  };

  render() {
    const { className, element } = this.props;

    const Component = element;

    // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'Component' does not have any con... Remove this comment to see the full error message
    return <Component className={cx('Divider', className, getPropClassesFromInstance(this))} />;
  }
}
